



























































import Vue from "vue";
import { default as moment, Moment } from "moment-timezone";
import { currentTimestamp, DAY_FORMAT } from "../api/Termine";
import { Studio } from "../api/Studio";
import ConfirmDialog from "../components/ConfirmDialog.vue";

export default Vue.extend({
  name: "Tagesabschluss",
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      zeit: {} as Moment,
      ueberschrift: "Tagesübersicht",
      tag: "heute",
      studios: [] as Studio[],
      studio: null as Studio | null,
    };
  },
  created() {
    const routeParams = this.$route.params;
    if (!routeParams || !routeParams.datum) {
      let datum = this.$store.getters["gewaehltesDatum"];
      if (!datum) {
        datum = currentTimestamp().format("YYYY-MM-DD");
        this.$store.dispatch("selectDatum", { datum });
      }
      this.$router.push({
        name: "Tagesabschluss-mit-Datum",
        params: { datum },
      });
      //return;
    } else {
      this.zeit = moment(routeParams.datum, "YYYY-MM-DD");
      const datum = this.zeit.format("YYYY-MM-DD");
      if (
        datum == routeParams.datum &&
        datum != this.$store.getters["gewaehltesDatum"]
      ) {
        // Gültiges, neues Parameter-Datum darf gespeichert werden
        this.$store.dispatch("selectDatum", { datum: routeParams.datum });
      }
    }
    this.zeit = currentTimestamp();
    this.studio = null;
    this.updateZeit();
    this.$store.dispatch("appLoading", true);
    const updateParameters = ((studio: Studio | null, zeit: Moment | null) => {
      if (studio) {
        this.studio = studio;
      }
      if (zeit) {
        this.zeit = zeit;
      }
      this.updateZeit();
    }).bind(this);
    this.$znaApi.getStudios().subscribe(
      (studios: Studio[]) => {
        this.studios = studios;

        if (routeParams) {
          let zeit = null;
          let studio = null;
          if (routeParams.datum) {
            zeit = moment(routeParams.datum, "YYYY-MM-DD");
          }
          if (routeParams.studio) {
            const studioBezeichner = routeParams.studio;
            const filteredStudios = studios.filter(
              (studio: Studio) => studio.bezeichner == studioBezeichner
            );
            if (filteredStudios.length) {
              studio = filteredStudios[0];
            }
          }
          updateParameters(studio, zeit);
        }

        this.$store.dispatch("appLoading", false);
      },
      (error: string) => {
        this.$toast.add({
          severity: "error",
          summary: "Laden der Studios fehlgeschlagen",
          detail: error,
          life: 3000,
        });
        this.$store.dispatch("appLoading", false);
      }
    );
  },
  watch: {
    "$route.params.datum": function(datum) {
      console.debug("Tagesabschluss / Datum wechselt: " + datum);
      this.zeit = moment(datum, "YYYY-MM-DD");
    },
    "$route.params.studio": function(studio) {
      console.debug("Tagesabschluss / Studio-Bezeichner wechselt: " + studio);
      const studioKandidaten = this.studios.filter(
        (s) => s.bezeichner == studio
      );
      this.studio = studioKandidaten.length ? studioKandidaten[0] : null;
    },
    tag: function(tag) {
      console.debug("Tagesabschluss / Datum wechselt: " + tag);
      this.zeit = moment(tag, "YYYY-MM-DD");
      this.$nextTick().then(() => this.checkChangeRoute(this.studio));
    },
    studio: function() {
      console.debug(
        "Tagesabschluss / Studio-Bezeichner wechselt: " +
          this.studio?.bezeichner
      );
      this.$nextTick().then(() => this.checkChangeRoute(this.studio));
    },
  },
  computed: {
    darfTageAuswaehlen() {
      return this.$znaApi.darfTageAuswaehlen();
    },
    darfTageLoeschen() {
      return this.$znaApi.darfTageLoeschen();
    },
  },
  methods: {
    checkChangeRoute(studio: Studio | null) {
      if (studio) {
        const nextRouteName = "Tagesabschluss-mit-Datum-und-Studio";
        if (this.$route.name != nextRouteName) {
          console.log("Wechsle zu Tagesabschluss-mit-Datum-und-Studio");
          this.$router.push({
            name: nextRouteName,
            params: {
              datum: this.zeit.format("YYYY-MM-DD"),
              studio: studio.bezeichner,
            },
          });
        }
      } else {
        const nextRouteName = "Tagesabschluss-mit-Datum";
        if (this.$route.name != nextRouteName) {
          console.log("Wechsle zu Tagesabschluss-mit-Datum");
          this.$router.push({
            name: nextRouteName,
            params: { datum: this.zeit.format("YYYY-MM-DD") },
          });
        }
      }
    },
    setDay(offset: number) {
      if (offset < 0) {
        this.zeit.subtract(1, "day");
      } else if (offset > 0) {
        this.zeit.add(1, "day");
      }
      this.updateZeit();
    },
    terminplan() {
      this.$router.push({
        path: `/termine/${this.studio?.bezeichner}/${this.zeit.format(
          "YYYY-MM-DD"
        )}`,
      });
    },
    updateZeit() {
      this.ueberschrift = `Tagesübersicht für ${this.zeit.format(DAY_FORMAT)}`;
      this.tag = this.zeit.format("YYYY-MM-DD");
    },
    tagLoeschen() {
      this.$nextTick(() => {
        (this.$refs.confirmDialog as any)
          .confirm(
            "delete",
            "Gewählten Tag löschen? Tagesabschluss zurücksetzen?",
            `Sind Sie sicher, dass Sie sämtliche Buchungsdaten für den <strong>${this.tag}</strong> unwiederbringlich löschen möchten?`
          ).then(() => {
            this.$nextTick(() => {
              this.$store.dispatch("appLoading", true);
              this.$znaApi
                .tagesTermineLoeschen(this.studio as Studio, this.zeit)
                .subscribe(
                  () => {
                    this.terminplan();
                    this.$toast.add({
                      severity: 'success',
                      summary: `Löschung erfolgreich ausgeführt`,
                      detail: `Alle Buchungsdaten für den ${this.tag} gelöscht.\nTagesabschluss zurückgesetzt.\nMonatsabschluss aktualisiert.`,
                      life: 5000
                    });
                  }, error => {
                    this.$toast.add({
                      severity: 'error',
                      summary: 'Fehler bei Datenlöschung',
                      detail: 'Leider kam es bei der Datenlöschung zu einem Fehler.\n\nBitte wenden Sie sich an den Programmierer und geben Sie genau an, was Sie getan haben und weshalb.',
                      life: 5000
                    });
                    this.$store.dispatch("appLoading", false);
                  });
            });
          },
          () => {
            this.$toast.add({
              severity: 'success',
              summary: 'Datenlöschung abgebrochen',
              detail: 'Okay, Schwein gehabt.\n\nBitte bei dieser Funktion wirklich aufpassen und einen kühlen Kopf bewahren.',
              life: 5000
            });
            this.$store.dispatch("appLoading", false);
          })
      });
    },
  },
});
